// Job type → tag label, ported from ionq-cloud-ui's JobTag render branches
// (src/components/Jobs/JobTag.tsx). The donor's `circuits: null → empty tag`
// arm is NOT ported: v0.3's stripUndefined dropped null circuits before the
// wire, so the legacy client only ever saw undefined → 'N/A', same as here.

const TYPE_LABELS: Record<string, string> = {
    'quantum-function': 'q.function',
    json: 'circuit',
    'ionq.circuit.v0': 'circuit',
    'ionq.optimization.v0': 'optimization',
    'ionq.apps.hybrid.optimization.v0': 'optimization',
};

export const getJobTypeLabel = (
    type: string | undefined,
    circuits: number | undefined,
): string => {
    if (!type) return 'N/A';
    if (type === 'circuit') {
        if (typeof circuits === 'number') {
            return circuits > 1 ? 'multicircuit' : 'circuit';
        }
        return 'N/A';
    }
    return TYPE_LABELS[type] ?? type;
};
